var _a;
import { useCallback, useEffect, useState } from "react";
var themeStorageKey = "prefers-color-theme";
var themeDomAttribute = "data-fr-theme";
var useMutationObserver = function (domNodeSelector, observerOptions, cb) {
    useEffect(function () {
        var targetNode = document.querySelector(domNodeSelector);
        var observer = new MutationObserver(cb);
        if (targetNode)
            observer.observe(targetNode, observerOptions);
        return function () {
            observer.disconnect();
        };
    }, [domNodeSelector, observerOptions, cb]);
};
var options = { attributes: true };
var defaultTheme = 'system';
if (typeof window !== "undefined") {
    defaultTheme = (_a = window.localStorage.getItem("prefers-color-theme")) !== null && _a !== void 0 ? _a : 'system';
}
var useTheme = function () {
    var _a = useState(defaultTheme), theme = _a[0], setTheme = _a[1];
    var handler = useCallback(function (mutationList) {
        mutationList.forEach(function (mutation) {
            if (mutation.type === "attributes" &&
                mutation.attributeName === themeDomAttribute) {
                var _theme = document.documentElement.getAttribute(themeDomAttribute);
                setTheme(_theme || defaultTheme);
            }
        });
    }, []);
    useMutationObserver("html", options, handler);
    useEffect(function () {
        if (!theme) {
            var _theme = document.documentElement.getAttribute(themeDomAttribute);
            setTheme(_theme || defaultTheme);
        }
    }, [theme]);
    return theme;
};
export { themeStorageKey, themeDomAttribute, useTheme };
